import { RightIcon } from "@/components/icons/right-icon";
import { Toggle } from "@/components/toggle";
import { cn } from "@/utils/cn";
import { memo } from "react";

const ExternalLinkIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M10 3H15V8M15 3L7.5 10.5M7 5H4C3.45 5 3 5.45 3 6V14C3 14.55 3.45 15 4 15H12C12.55 15 13 14.55 13 14V11"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

type SettingsRowRight =
  | { type: "chevron"; value?: string }
  | { type: "external-link" }
  | {
      type: "toggle";
      checked: boolean;
      onCheckedChange: (checked: boolean) => void;
      disabled?: boolean;
    };

interface SettingsRowProps {
  icon: React.ReactNode;
  label: string;
  right?: SettingsRowRight;
  onClick?: () => void;
}

export const SettingsRow = memo(function SettingsRow({
  icon,
  label,
  right,
  onClick,
}: SettingsRowProps) {
  const isToggle = right?.type === "toggle";

  const inner = (
    <>
      <div className="flex items-center gap-3">
        <span className="text-os-brand flex h-6 w-6 flex-shrink-0 items-center justify-center">
          {icon}
        </span>
        <span className="text-[15px] font-medium text-gray-900">{label}</span>
      </div>

      <div className="flex items-center gap-1.5">
        {right?.type === "chevron" && right.value && (
          <span className="text-[13px] text-[#620ad5]">{right.value}</span>
        )}
        {right?.type === "chevron" && <RightIcon className="h-4 w-4 text-os-brand" />}
        {right?.type === "external-link" && (
          <span className="text-gray-400">
            <ExternalLinkIcon />
          </span>
        )}
        {right?.type === "toggle" && (
          <Toggle
            checked={right.checked}
            onChange={right.onCheckedChange}
            disabled={right.disabled}
          />
        )}
      </div>
    </>
  );

  const baseClass =
    "flex w-full items-center justify-between pl-[15px] pr-[12px] py-[14px] rounded-[32px] bg-[rgba(255,255,255,0.8)] shadow-[0px_8px_64.7px_0px_rgba(64,0,255,0.1)]";

  if (isToggle) {
    return <div className={baseClass}>{inner}</div>;
  }

  return (
    <button type="button" className={cn(baseClass, "active:bg-gray-100")} onClick={onClick}>
      {inner}
    </button>
  );
});
